import { RANKS, SUITS } from '../scoring/ScoringConstants.js';
import { Card } from './Card.js';

/**
 * Deck Model managing card generation, shuffling, cutting, and dealing.
 */
export class Deck {
  constructor(options = {}) {
    this.deckCount = Number(options.decks || 1);
    this.includeJokers = Boolean(options.jokers);
    this.cards = [];
    this.reset();
  }

  reset() {
    this.cards = [];
    for (let pack = 0; pack < this.deckCount; pack++) {
      for (const su of SUITS) {
        for (const r of RANKS) {
          this.cards.push(new Card({
            r,
            s: su,
            id: `${r}${su}#${pack}`
          }));
        }
      }
      if (this.includeJokers) {
        this.cards.push(new Card({ r: 0, s: 'J', id: `W${pack}a`, wild: true }));
        this.cards.push(new Card({ r: 0, s: 'J', id: `W${pack}b`, wild: true }));
      }
    }
    return this;
  }

  shuffle() {
    Deck.shuffleArray(this.cards);
    return this;
  }

  draw(count = 1) {
    if (count <= 1) return this.cards.pop() || null;
    const drawn = [];
    for (let i = 0; i < count; i++) {
      const c = this.cards.pop();
      if (c) drawn.push(c);
    }
    return drawn;
  }

  deal(count = 1) {
    return this.draw(count);
  }

  cut(index) {
    if (!this.cards.length) return null;
    const idx = Math.max(0, Math.min(this.cards.length - 1, index != null ? index : Math.floor(this.cards.length / 2)));
    return this.cards[idx];
  }

  pop() {
    return this.cards.pop();
  }

  splice(start, deleteCount, ...items) {
    return this.cards.splice(start, deleteCount, ...items);
  }

  get remaining() {
    return this.cards.length;
  }

  get length() {
    return this.cards.length;
  }

  toPlain() {
    return this.cards.map(c => c.toPlain());
  }

  static shuffleArray(a) {
    if (!Array.isArray(a)) return a;
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  static makeDeck(nDecks = 1, jokers = false) {
    const d = new Deck({ decks: nDecks, jokers });
    return d.cards;
  }
}
